import isBackOffice from 'utils/appUtils';
import navigate, { navtoLogin } from 'utils/navigate';
import apiClient, { endpoints } from 'app/apiClient';
import t from 'app/translations';
import {
  call, put, takeLatest, all,
} from 'redux-saga/effects';
import {
  setServiceErrorNotification,
} from 'notifications/notificationsActions';
import {
  LOAD_BO_APPLICATION_REQUEST,
  loadBoApplicationSuccess,
} from './appActions';

export const apiGetRequest = endpoint => apiClient.getRequest(endpoint);

export function* loadApplication() {
  const endpoint = endpoints.loadUser;

  try {
    const response = yield call(apiGetRequest, endpoint);

    const isAuthorized = response.data.isBackOffice;

    if (isAuthorized) {
      yield put(loadBoApplicationSuccess(response.data));
    } else {
      navigate('/welcome');
    }
  } catch (e) {
    if (isBackOffice) {
      navtoLogin();
    } else {
      yield put(setServiceErrorNotification(e.message || t('Generic.fetchFailedAuth')));
    }
  }
}

export default function* appSaga() {
  yield all([
    takeLatest(LOAD_BO_APPLICATION_REQUEST, loadApplication),
  ]);
}
